import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';

import { useAiCopilot } from '../../../components/ai-copilot/context/use-ai-copilot';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { BillingForecastReportContent } from './billing-forecast-report-components/BillingForecastReportContent';

const BillingForecastReportLayout: React.FC = () => {
  const { isOpen, drawerWidth } = useAiCopilot();

  return (
    <Box
      sx={{
        transition: (theme) =>
          theme.transitions.create('margin-right', {
            easing: isOpen
              ? theme.transitions.easing.easeOut
              : theme.transitions.easing.sharp,
            duration: isOpen
              ? theme.transitions.duration.enteringScreen
              : theme.transitions.duration.leavingScreen,
          }),
        marginRight: isOpen ? `${drawerWidth}px` : 0,
      }}
    >
      <VyLayout>
        <BillingForecastReportContent />
      </VyLayout>
    </Box>
  );
};

const BillingForecastReportPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Billing Forecast Report</title>
      </Helmet>
      <BillingForecastReportLayout />
    </>
  );
};

const BillingForecastReportPageWithSuspenseBoundary = withSuspenseBoundary(
  withGlobalSearchParams(BillingForecastReportPage),
);

export { BillingForecastReportPageWithSuspenseBoundary as BillingForecastReportPage };
